export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/b3dc542ec1b5794376b3d1da54a4e35b.svg";